<div id="ic-account-tb-container" class="nt-position-relative" [class.ic-account-tb--header]="placement() === 'header'">

  <!--
    The navbar `Name` frame: a 20px globe, the account in effect, and the double chevron.
    Anchored trigger, @if'd overlay, document-click and escape dismissal - the header's own
    overlay pattern, taken from the user menu in toolbar-user.
  -->
  <!--
    `aria-haspopup` says `tree`, matching the role the panel actually renders. It said
    `listbox` while the panel was a listbox; the panel became a tree because listbox options
    may not contain interactive descendants and every row carries two buttons. A trigger that
    promises one popup role and then opens another has mis-set the expectation before the user
    has even arrived.
  -->
  <div class="ic-account-tb-trigger"
      #accountPanelTrigger
      role="button"
      [class.ic-account-tb-trigger--static]="!isInteractive()"
      [attr.tabindex]="isInteractive() ? 0 : -1"
      [attr.aria-haspopup]="isInteractive() ? 'tree' : null"
      [attr.aria-expanded]="isPanelOpen()"
      (click)="onTriggerClick($event)"
      (keydown)="onTriggerKeydown($event)"
  >
    <span class="ic-account-tb-trigger__glyph" aria-hidden="true">
      <ic-icon-svg iconName="globe" [svgResizable]="true"></ic-icon-svg>
    </span>

    <span class="ic-account-tb-trigger__name">
      @if (selectedAccount(); as account) {
        {{ account.accountName }}
      } @else {
        {{ 'STRINGS.SELECT_ACCOUNT' | translate }}
      }
    </span>

    <!-- Nothing to switch to, so no affordance to open and no chevron. -->
    @if (isInteractive()) {
      <span class="ic-account-tb-trigger__glyph" aria-hidden="true">
        <ic-icon-svg iconName="chevron-up-down" [svgResizable]="true"></ic-icon-svg>
      </span>
    }
  </div>

  @if (isPanelOpen()) {
    <!-- Dims the page behind the panel, the way a modal does. Purely a backdrop: it sits
      outside both the trigger and the panel, so the existing document:click dismissal
      already closes on a click here and needs no handler of its own. aria-hidden because
      it carries no content a screen reader should reach. -->
    <div class="ic-account-tb-scrim" aria-hidden="true"></div>
    <div class="ic-account-tb-panel" #accountPanel>
      <ic-account-select-panel
          [accounts]="accounts()"
          [selectedAccountId]="selectedAccountId()"
          [expandedAccountIds]="expandedAccountIds()"
          [compact]="placement() === 'header'"
          (accountSelected)="onPanelAccountSelected($event)"
          (expandToggled)="onPanelExpandToggled($event)"
          (accountSettingsClicked)="onPanelAccountSettings($event)"
          (accountSelectClicked)="onPanelAccountSelectClicked()"
          (payNowClicked)="onPanelPayNow()"
      ></ic-account-select-panel>
    </div>
  }
</div>
